export default {
  methods: {
    clearSelectedTable() {
      this.$refs.selectableTable.clearSelected();
    },
  },
};
